import React from 'react';
import './Blog.css';

const Blog = () => {
    const navigate = (path) => {
        window.history.pushState({}, '', path);
        window.dispatchEvent(new PopStateEvent('popstate'));
    };
    return (
        <div className="blog-page">
            <div className="blog-header">
                <h1 className="blog-title">Why Queues are Quietly Killing Your Business</h1>
                <p className="blog-subtitle">The hidden cost of waiting and how Zopeo is revolutionizing the customer experience.</p>
            </div>

            <div className="blog-content">
                <section className="blog-section">
                    <h2>The Silent Time Thief</h2>
                    <p>
                        In today's fast-paced world, time is the most valuable currency. Yet, we spend an average of 6 months of our lives
                        waiting in lines. For your customers, every minute spent in a physical queue is a minute they could have spent
                        actually shopping, relaxing, or being productive. This frustration doesn't just dissipate when they reach the
                        counter—it lingers, affecting their entire perception of your brand.
                    </p>
                </section>

                <section className="blog-section">
                    <h2>The Business Impact: More Than Just Annoyance</h2>
                    <div className="impact-grid">
                        <div className="impact-card">
                            <h3>Revenue Leakage</h3>
                            <p>Abandoned queues are lost sales. When a customer sees a long line, they often walk away before even picking up a product.</p>
                        </div>
                        <div className="impact-card">
                            <h3>Staff Burnout</h3>
                            <p>Managing an unruly physical crowd is stressful for employees, leading to higher turnover and lower service quality.</p>
                        </div>
                        <div className="impact-card">
                            <h3>Negative Feedback</h3>
                            <p>One bad experience with a long wait can lead to negative reviews that stay online forever, damaging your reputation.</p>
                        </div>
                    </div>
                </section>

                <section className="blog-section featured">
                    <h2>The Psychology of Waiting</h2>
                    <p>
                        It's not just about the actual time; it's about the <em>perceived</em> time. Occupied time feels shorter than unoccupied time.
                        Uncertain waits feel longer than known waits. Physical queues force customers to stand in one spot, staring at the back
                        of someone's head—that's the ultimate "unoccupied" wait. This drains their mood, making them less likely to engage with
                        your premium offerings or return in the future.
                    </p>
                </section>

                <section className="blog-section">
                    <h2>How Zopeo Solves the Equation</h2>
                    <p>
                        Zopeo isn't just a queue manager; it's a customer experience platform. By transforming physical lines into
                        virtual waiting rooms, we give time back to your customers and control back to you.
                    </p>
                    <ul className="solution-list">
                        <li><strong>Virtual Queuing:</strong> Scan a QR and stay updated while you continue to shop or grab a coffee.</li>
                        <li><strong>Real-time Notifications:</strong> No more guessing. We notify users exactly when it's their turn.</li>
                        <li><strong>Deep Analytics:</strong> Understand your peak hours and optimize staff allocation to eliminate bottlenecks.</li>
                        <li><strong>Priority Access:</strong> Offer Zopeo Pass for those who need to move faster, creating a new revenue stream.</li>
                    </ul>
                </section>
            </div>

            <div className="blog-footer">
                <div className="cta-container">
                    <h3>Ready to eliminate the wait?</h3>
                    <button className="btn primary" onClick={() => navigate('/register')}>Get Started for Free</button>
                </div>
            </div>

            <div className="blog-accent-glow" />
        </div>
    );
};

export default Blog;
